"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTaskAbortedEvent = void 0;
/**
 * @deprecated This event is deprecated and will be removed in the future. Please use `ProcessInstanceTerminatedEvent` instead.
 */
class UserTaskAbortedEvent extends Event {
    constructor(userTask) {
        super(UserTaskAbortedEvent.type, {
            bubbles: true,
            cancelable: false,
        });
        this.userTask = userTask;
        console.warn('UserTaskAbortedEvent is deprecated and will be removed in the future. Please use `ProcessInstanceTerminatedEvent` instead.');
    }
}
exports.UserTaskAbortedEvent = UserTaskAbortedEvent;
UserTaskAbortedEvent.type = 'onUserTaskAborted';
